import React, { useState } from 'react';
import QuestionWrapper from '../../../../wrappers/question_wrapper/index';

import styles from '../../questionnaire.module.css';

export default function Rating({
  icons = [],
  wrapperStyles = {},
  star = false,
  onSubmit,
  onBack,
  title,
  para,
  answers = {},
  numberRating = false,
  keyForAnswer = 'rating',
  textLabels = [],
}) {
  const [selected, setSelected] = useState(null);
  const starSvg = (
    <svg width='36' height='33' viewBox='0 0 36 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.9234 28.3146C18.352 28.0224 17.6751 28.0221 17.1035 28.3138L9.539 32.1742C8.06831 32.9248 6.37305 31.6707 6.6604 30.0447L8.07607 22.0342C8.19318 21.3716 7.96924 20.6945 7.48014 20.2324L1.52181 14.6027C0.303342 13.4515 0.956774 11.402 2.61675 11.1685L10.942 9.99732C11.5886 9.90635 12.1502 9.50539 12.4461 8.92327L16.2172 1.50638C16.9586 0.0483107 19.0414 0.0483135 19.7828 1.50638L23.5539 8.92327C23.8498 9.50539 24.4114 9.90635 25.058 9.99732L33.3833 11.1685C35.0432 11.402 35.6967 13.4515 34.4782 14.6027L28.5199 20.2324C28.0308 20.6945 27.8068 21.3716 27.9239 22.0342L29.3388 30.0402C29.6263 31.6669 27.9293 32.9211 26.4586 32.1688L18.9234 28.3146Z'
        fill='#314D69'
      />
    </svg>
  );

  // Ensure icon `number` fields are present
  const withNumberedIcons = icons.map((icon, i) => ({
    ...icon,
    number: icon.number ?? i + 1,
    icon: star ? starSvg : icon.icon,
  }));

  const isSelected = (icon) => {
    return star
      ? selected != null && selected.number >= icon.number
      : selected != null && selected.number === icon.number;
  };

  if (icons.filter((i) => i.number === undefined).length === icons.length) {
    icons.map((i, index) => (i.number = index + 1));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selected && onSubmit) {
      const ratingValue = numberRating ? selected.number : selected.text;
      const answerData = { [keyForAnswer]: ratingValue };
      onSubmit(answerData);
    }
  };

  return (
    <QuestionWrapper onSubmit={handleSubmit} onBack={onBack} isDisabled={!selected}>
      <h5 className={styles.question}>{title}</h5>
      <p className={styles.question_para}>{para}</p>
      <div style={{ width: '100%', ...wrapperStyles }}>
        <div style={{ width: 'max-content', margin: '0px auto', minHeight: '70px' }} className={styles.icon_innr}>
          <div className={styles.icon_holder}>
            {withNumberedIcons.map((icon, index) => (
              <div
                key={index}
                onClick={() => {
                  setSelected(withNumberedIcons[index]);
                }}
                className={`${styles.icon_wrap} ${isSelected(withNumberedIcons[index]) ? styles.selected : ''}`}
              >
                {icon.icon}
              </div>
            ))}
          </div>
          {selected != null && <p className={styles.txt}>{selected.text}</p>}
        </div>
      </div>
    </QuestionWrapper>
  );
}
